export const theme = {
  colors: {
    primary: "",
    secondary: "",
    background: "#f5f4f4", // light grey
    text: "#041836", // dark grey
    white: "#ffffff",
    black: "#000000",
    link: "#1e88e5" // blue
  },
  breakpoints: {
    small: 480,
    medium: 768,
    large: 1050
  }
};
